'use client';

import { useState } from 'react';
import { PlayCircle } from 'lucide-react';
import dynamic from 'next/dynamic';

const MuxClipPlayer = dynamic(
  () => import('@/components/moments/MuxClipPlayer').then((mod) => mod.MuxClipPlayer),
  { ssr: false, loading: () => <div className="aspect-video bg-muted animate-pulse" /> }
);

interface VideoMediaProps {
  playbackId: string;
  startTime?: number;
  endTime?: number;
  className?: string;
}

export function VideoMedia({ playbackId, startTime = 0, endTime, className }: VideoMediaProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  const thumbnail = `https://image.mux.com/${playbackId}/thumbnail.jpg${startTime ? `?time=${startTime}` : ''}`;

  if (!isPlaying) {
    return (
      <div
        className={`relative aspect-video cursor-pointer group ${className || ''}`}
        onClick={() => setIsPlaying(true)}
      >
        <img
          src={thumbnail}
          alt="Video thumbnail"
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/30 transition-colors">
          <PlayCircle className="w-16 h-16 text-white drop-shadow-lg" />
        </div>
        <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-1.5 py-0.5 rounded">
          Click to play
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <MuxClipPlayer playbackId={playbackId} startTime={startTime} endTime={endTime} autoPlay />
    </div>
  );
}
